<template>
    <div class="radio-list">
        <label class="form-label" :for="id" :style="{ width: labelWidth }">
            <span v-if="required" style="color: #ff5a5a;">*</span>
            <span v-else style="visibility: hidden;">*</span>
            {{ label }}
        </label>
        <div v-for="(item, index) in finalOptions" :key="index" class="radio-item">
            <input
                class="radio_type"
                type="radio"
                :name="name"
                :id="item.value"
                :value="item.value"
                v-model="selectedValue"
                @change="handleChange"
            />
            <label :for="item.value" style="margin-right: 2rem;">{{ item.name }}</label>
        </div>
    </div>
</template>

<script>
export default {
    name: 'RadioList',
    props: {
        label: {
            type: String,
            required: false,
        },
        labelWidth: {
            type: String,
            default: '0%',
        },
        name: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: false,
            default: () => [
                { name: "默认", value: "1" },
            ],
        },
        value: {
            type: [String, Number],
            default: null
        },
        required: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            selectedValue: this.value
        };
    },
    computed: {
        finalOptions() {
            return this.options.length > 0 ? this.options : [
                { name: "默认", value: "1" },
            ];
        }
    },
    watch: {
        value(newValue) {
            this.selectedValue = newValue;
        },
        selectedValue(newValue) {
            // this.$emit('input', newValue);
            this.$emit('update:modelValue', newValue);
        }
    },
    methods: {
        // handleChange() {
        //     this.$emit('input', this.selectedValue);
        // }
        handleChange() {
            this.$emit('update:modelValue', this.selectedValue);
        }
    }
};
</script>

<style scoped>
.radio-list {
    display: flex;
    justify-content: start;
    padding: 0.75rem 1rem 0.75rem 0;
}

.radio-item {
    display: inline-flex;
    align-items: center;
    white-space: nowrap;
}

label {
    line-height: 20px;
    display: inline-block;
    margin-left: 5px;
    margin-right: 15px;
    color: #94a3b8;
}

.radio_type {
    width: 20px;
    height: 20px;
    appearance: none;
    position: relative;
}

.radio_type:before {
    content: '';
    width: 20px;
    height: 20px;
    border: 2px solid #00ff96;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
}

.radio_type:checked:before {
    content: '';
    width: 20px;
    height: 20px;
    border: 2px solid #00ff96;
    display: inline-block;
    border-radius: 50%;
    vertical-align: middle;
}

.radio_type:checked:after {
    content: '';
    width: 12px;
    height: 12px;
    background: #00ff96;
    border-radius: 50%;
    display: block;
    position: absolute;
    top: 5px;
    left: 4px;
}

.radio_type:checked + label {
    color: #00ff96;
}
</style>